(() => {
  if (window.plDeliveryFaqInitialized) return;
  window.plDeliveryFaqInitialized = true;

  const active = new WeakMap();

  document.addEventListener('click', (event) => {
    const summary = event.target.closest('.pl-delivery-faq__list summary');
    if (!summary) return;

    const details = summary.parentElement;
    const previous = active.get(details);
    const shouldOpen = !(previous ? previous.targetOpen : details.open);
    event.preventDefault();

    const startHeight = details.getBoundingClientRect().height;
    if (previous) previous.animation.cancel();
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      details.open = shouldOpen;
      active.delete(details);
      details.style.removeProperty('height');
      details.style.removeProperty('overflow');
      return;
    }

    details.open = true;
    const endHeight = shouldOpen ? details.scrollHeight : summary.getBoundingClientRect().height;
    details.style.overflow = 'hidden';
    const animation = details.animate(
      [{ height: `${startHeight}px` }, { height: `${endHeight}px` }],
      { duration: 260, easing: 'cubic-bezier(.22, 1, .36, 1)' }
    );
    active.set(details, { animation, targetOpen: shouldOpen });
    animation.onfinish = () => {
      if (active.get(details)?.animation !== animation) return;
      details.open = shouldOpen;
      details.style.removeProperty('height');
      details.style.removeProperty('overflow');
      active.delete(details);
    };
  });
})();
